import * as React from 'react';
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Title, PageHeader} from "ah-tools";
import {Button, Form, Segment} from "semantic-ui-react";
import Placeholder from "../components/Placeholder";
import {TextField} from "material-ui";
import {isProcessing} from "../actions/processingActions";
import {PROC_UPDATE_ACCESS} from "../actions";
import {updateProfile, updateProfilePassword} from "../actions/userActions";
import {MIN_PASSWORD_LENGTH} from "../misc/vars";

const _pwState = {
	old: '',
	next: '',
	next2: ''
};

class Profile extends React.Component {
	static defaultProps = {
		isUpdating: false,
		isChangingPW: false,
		hasErrors: false,
		onUpdate: () => alert('onUpdate() not implemented!'),
		onChangePW: () => alert('onChangePW() not implemented!')
	};
	
	state = {
		user: {},
		password: _pwState
	};
	
	get = (name) => this.state.user[name] || this.props.user[name];
	set = (name, value = '') => this.setState(state => ({
		...state,
		user: {
			[name]: value
		}
	}));
	merged = () => ({
		...this.props.user,
		...this.state.user
	});
	reset = () => this.setState(state => ({...state, user: {}}));
	
	pw = (index, value='') => this.setState(state => ({
		...state,
		password: {
			...state.password,
			[index]: value
		}
	}));
	getPW = (index) => this.state.password[index];
	resetPW = () => this.setState(state => ({...state, password: _pwState}));
	validPW = () => this.state.password.old !== '' &&
					this.state.password.next !== '' &&
					this.state.password.next2 === this.state.password.next &&
					!this.props.hasErrors;
	
	render() {
		const {user, isUpdating, onUpdate, isChangingPW, onChangePW, hasErrors} = this.props;
		// const {name} = this.state.user;
		if (!user) {
			return <Placeholder repeat={3} margin={25}/>
		}
		return (
			<div>
				<PageHeader>
					<Title style={{margin: 0, pading: 0}}>Profil: {user.name}</Title>
				</PageHeader>
				<Segment padded="very">
					<h3>Daten anpassen</h3>
					<Form onSubmit={() => onUpdate(this.merged(), () => this.reset())} loading={isUpdating}>
						<Form.Field style={{display: 'flex', alignItems: 'flex-end'}}>
							<TextField
								value={this.get('name')}
								hintText={"Name"} floatingLabelText={"Name"}
								required={true}
								onChange={(_, value) => this.set('name', value)}
							/>
							<TextField
								type={"email"}
								value={this.get('email')}
								hintText={"E-Mail"} floatingLabelText={"E-Mail"}
								required={true}
								onChange={(_, value) => this.set('email', value)}
							/>
							<Button type={"submit"} disabled={hasErrors} style={{marginBottom: 8, marginLeft: 10}} positive={true} inverted={true}>Ändern</Button>
						</Form.Field>
					</Form>
				</Segment>
				<Segment padded={'very'}>
					<h3>Passwort ändern</h3>
					<Form loading={isChangingPW} onSubmit={() => onChangePW(this.state.password, () => this.resetPW())}>
						<Form.Field>
							<TextField
								type={"password"}
								value={this.getPW('old')}
								hintText={"Aktueller Passwort"} floatingLabelText={"Aktuelles Passwort"}
								required={true}
								onChange={(_, value) => this.pw('old', value)}
							/>
						</Form.Field>
						<Form.Field style={{display: 'flex', alignItems: 'flex-end'}}>
							<TextField
								type={"password"}
								value={this.getPW('next')}
								hintText={"Neues Passwort"} floatingLabelText={`Neues Passwort`}
								required={true}
								minLength={MIN_PASSWORD_LENGTH}
								onChange={(_, value) => this.pw('next', value)}
								errorText={this.getPW('next').length && this.getPW('next').length < MIN_PASSWORD_LENGTH ? `min. ${MIN_PASSWORD_LENGTH} Zeichen` : null}
							/>
							<TextField
								type={"password"}
								value={this.getPW('next2')}
								hintText={"Neues Passwort bestätigen"} floatingLabelText={`Neues Passwort bestätigen`}
								required={true}
								minLength={MIN_PASSWORD_LENGTH}
								onChange={(_, value) => this.pw('next2', value)}
								errorText={this.getPW('next2').length && this.getPW('next2').length < MIN_PASSWORD_LENGTH ? `min. ${MIN_PASSWORD_LENGTH} Zeichen` : null}
							/>
							<Button disabled={!this.validPW()} style={{marginBottom: 8, marginLeft: 10}} positive={true} inverted={true}>Ändern</Button>
						</Form.Field>
					</Form>
				</Segment>
			</div>
		);
	}
}

const m2s = state => ({
	user: state.user.data,
	isUpdating: isProcessing(state, PROC_UPDATE_ACCESS),
	hasErrors: state.error.length > 0
});
const m2d = dispatch => ({
	onUpdate: (data, onSuccess) => dispatch(updateProfile(data, onSuccess)),
	onChangePW: (data, onSuccess) => dispatch(updateProfilePassword(data, onSuccess))
});

export default connect(m2s, m2d)(translate()(Profile));


// WEBPACK FOOTER //
// ./src/containers/ProfileController.js